import SectionTitle from './SectionTitle'
import React from 'react'

export default function Summary() {
    return (
        <div className="space-y-2">
            <SectionTitle title="SUMMARY"/>
            <p className="text-stone text-justify">Passionate Software Engineering Leader with 10+ years of experience in developing web applications and backend systems. Able to lead and grow Engineering teams. Skilled at writing clear, concise code that is easy to maintain and troubleshoot. Experienced in working with both small and large teams across multiple projects and companies.</p>
        </div>
    )
}